import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon, ShieldCheck } from 'lucide-react';
const HeaderEMFInvestigation = () => {
  return <header className="bg-white" data-id="element-3482">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-3483"></div>
      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-3484">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-3485">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-3486">
            MEDPRESS GAZETTE
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-3487">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>
        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-3488">
          <div className="text-left" data-id="element-3489">VOL. 129, NO. 12</div>
          <div className="text-left sm:text-center" data-id="element-3490">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-3491">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>
      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-3492">
        <div className="max-w-4xl mx-auto" data-id="element-3493">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-3494">
            INVESTIGATIVE REPORT
          </div>
          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-5" data-id="element-3495">
            Nurse Practitioner Investigates: Do EMF 'Protection' Stickers
            Actually Work, or Is It Another Wellness Scam?
          </h1>
          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-3496">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-3497">
              <img src="https://cdn.magicpatterns.com/uploads/2vhcTePUouBXhTZ9g92HeZ/1.png" alt="Rebecca Marsh" className="w-full h-full object-cover" data-id="element-3498" />
            </div>
            <div className="flex-1" data-id="element-3499">
              <div className="flex items-center" data-id="element-3500">
                <div className="font-medium text-gray-900 text-lg" data-id="element-3501">
                  By Rebecca Marsh, RN, MSN
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-3502">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-3503" />
                  <span className="text-xs ml-1 font-medium" data-id="element-3504">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-3505">
                Former Head of Integrative Medicine, Cedar Sinai Medical Center
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-3506">
                <div className="flex items-center mr-4" data-id="element-3507">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-3508" />
                  <span data-id="element-3509">11 min read</span>
                </div>
                <div className="flex items-center" data-id="element-3510">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-3511" />
                  <span data-id="element-3512">28,413 views</span>
                </div>
              </div>
              <div className="flex items-center text-xs text-gray-500 mt-1" data-id="element-3513">
                <ShieldCheck className="h-3.5 w-3.5 text-blue-600 mr-1 flex-shrink-0" data-id="element-3514" />
                Medically Reviewed by{' '}
                <span className="text-blue-600 underline ml-1" data-id="element-3515">
                  Robert Hill, MD, FACP
                </span>
              </div>              
            </div>
          </div>
          <p className="font-serif text-gray-700 text-base sm:text-lg mb-6 leading-relaxed border-l-4 border-gray-300 pl-4 italic" data-id="element-3516">
            After 30 years in medicine, I've seen every "miracle cure" come and
            go. So when I found out about "EMF protection" stickers, I decided
            to run an 8-month investigation. What I discovered will save you
            hundreds of dollars — and might actually change the way you use your
            devices.
          </p>
          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-3517">
            <div className="mb-1 flex items-center" data-id="element-3518">
              <span className="font-medium mr-2" data-id="element-3519">Published by:</span>
              MedPress Gazette Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-3520">
              <span className="font-medium mr-2" data-id="element-3521">Published:</span>
              February 2026
            </div>
          </div>
        </div>
      </div>
      {/* Author image */}
      <div className="px-4 sm:px-8 py-2 border-b border-gray-200" data-id="element-3522">
        <div className="max-w-4xl mx-auto" data-id="element-3523">
          <div className="sm:flex items-center" data-id="element-3524">
            <div className="sm:w-1/3 mb-4 sm:mb-0 sm:mr-6" data-id="element-3525">
              <img src="https://cdn.magicpatterns.com/uploads/2vhcTePUouBXhTZ9g92HeZ/1.png" alt="Rebecca Marsh, RN, MSN" className="w-full rounded-lg shadow-md" data-id="element-3526" />
            </div>
            <div className="sm:w-2/3" data-id="element-3527">
              <p className="text-sm text-gray-700 mb-2" data-id="element-3528">
                <span className="font-bold" data-id="element-3529">Rebecca Marsh, RN, MSN</span> has
                spent three decades in clinical practice specializing in
                integrative medicine approaches. As the Former Head of
                Integrative Medicine at Cedar Sinai Medical Center, she has
                evaluated hundreds of wellness products and alternative
                treatments throughout her career.
              </p>
              <p className="text-sm text-gray-700" data-id="element-3530">
                Her investigative work focuses on separating evidence-based
                treatments from marketing hype, helping people make informed
                health decisions based on scientific testing rather than trends.
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderEMFInvestigation;